import React from 'react';
import PropTypes, { func, string, bool, number } from 'prop-types';

import Forms from '.';

const Input = React.forwardRef(
    (
        {
            append,
            autoFocus,
            autocomplete,
            className,
            disabled,
            flatBottom,
            inlineLabel,
            label,
            labelIsBold,
            labelIsHidden,
            maxLength,
            name,
            onBlur,
            onChange,
            onFocus,
            onKeyDown,
            onKeyPress,
            placeholder,
            readonly,
            required,
            success,
            type = 'text',
            value
        },
        ref
    ) => {
        const renderInput = () => (
            <input
                autoComplete={autocomplete}
                autoFocus={autoFocus}
                className={className}
                disabled={disabled}
                id={name}
                maxLength={maxLength}
                name={name}
                onBlur={onBlur}
                onChange={onChange}
                onFocus={onFocus}
                onKeyDown={onKeyDown}
                onKeyPress={onKeyPress}
                placeholder={placeholder}
                readOnly={readonly}
                ref={ref}
                required={required}
                success={success}
                type={type}
                value={value}
            />
        );

        const renderInputGroup = () => (
            <div className="input-group">
                <div className="input-group__content">{renderInput()}</div>
                {append && <div className="input-group__append">{append}</div>}
            </div>
        );

        return (
            <Forms.FormGroup
                flatBottom={flatBottom}
                htmlFor={name}
                inlineLabel={inlineLabel}
                label={label}
                labelIsBold={labelIsBold}
                labelIsHidden={labelIsHidden}
            >
                {append ? renderInputGroup() : renderInput()}
            </Forms.FormGroup>
        );
    }
);

Input.propTypes = {
    append: PropTypes.node,
    autoFocus: bool,
    autocomplete: string,
    className: string,
    disabled: bool,
    flatBottom: bool,
    inlineLabel: bool,
    label: string.isRequired,
    labelIsBold: bool,
    labelIsHidden: bool,
    maxLength: number,
    name: string.isRequired,
    onBlur: func,
    onChange: func,
    onFocus: func,
    onKeyDown: func,
    onKeyPress: func,
    placeholder: string,
    readonly: bool,
    required: bool,
    type: string,
    value: string
};

export default Input;
